import * as type from './constant';

const initialState = {
  dataUser: [],
  dataUserPermission: [],

  updatedUser: null,
  addedUser: null,
  deletedUser: null,
  restoredUserPermissions: null,
  generatedPasswordlessToken: null,

  loading: false,
  loadingManipulation: false,
  error: null,
  errorManipulation: null,
};
export default (state = initialState, action) => {

  switch (action.type) {

    case type.GET:
      return {
        ...state,
        updatedUser: null,
        addedUser: null,
        deletedUser: null,
        loading: true,
        loadingManipulation: false,
        error: null,
        errorManipulation: null,
        generatedPasswordlessToken: null,
      };

    case type.GET_SUCCESS:
      return {
        ...state,
        dataUser: [...action.payload],
        loading: false,
      };

    case type.GET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case type.ADD:
      return {
        ...state,
        addedUser: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.ADD_SUCCESS:
      return {
        ...state,
        addedUser: action.payload,
        loadingManipulation: false,
      };

    case type.UPDATE:
      return {
        ...state,
        updatedUser: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.UPDATE_SUCCESS:
      return {
        ...state,
        updatedUser: action.payload,
        loadingManipulation: false,
      };

    case type.DELETE:
      return {
        ...state,
        deletedUser: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.DELETE_SUCCESS:
      return {
        ...state,
        deletedUser: action.payload,
        loadingManipulation: false,
      };

    case type.MANIPULATION_ERROR:
      return {
        ...state,
        loadingManipulation: false,
        errorManipulation: action.error,
      };

    case type.GET_PERMISSION:
      return {
        ...state,
        loadingManipulation: false,
        errorManipulation: null,
      };

    case type.GET_PERMISSION_SUCCESS:
      return {
        ...state,
        [`dataUserPermission${action.role}`]: [...action.payload],
        loadingManipulation: false,
      };

    case type.RESTORE_PERMISSIONS:
      return {
        ...state,
        restoredUserPermissions: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.RESTORE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        restoredUserPermissions: action.payload,
        loadingManipulation: false,
      };

    case type.PASSWORDLESS_TOKEN:
      return {
        ...state,
        [`generatedPasswordlessToken${action.id}`]: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.PASSWORDLESS_TOKEN_SUCCESS:
      return {
        ...state,
        [`generatedPasswordlessToken${action.id}`]: action.payload,
        loadingManipulation: false,
      };

    default:
      return state;
  }
};
